"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 8. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValidationResultConverter_1 = require("../../core/model/errors/conversions/ValidationResultConverter");

var ValidationResult_1 = require("../../core/model/errors/ValidationResult");

var utils_1 = require("../../core/utils");

var PriceChangeIndex_1 = require("../model/PriceChangeIndex");

var PriceChangeIndexConverter_1 = require("./PriceChangeIndexConverter");
/**
 * @author Radek Beran
 */


var PriceChangeIndexConverterImpl =
/*#__PURE__*/
function (_PriceChangeIndexConv) {
  _inherits(PriceChangeIndexConverterImpl, _PriceChangeIndexConv);

  function PriceChangeIndexConverterImpl(validationResultConverter) {
    var _this;

    _classCallCheck(this, PriceChangeIndexConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceChangeIndexConverterImpl).call(this));
    _this.validationResultConverter = validationResultConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(PriceChangeIndexConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new PriceChangeIndex_1.PriceChangeIndex(PriceChangeIndex_1.PriceChangeIndex.schema.value.valueOf(conversions.toBigNumber(source.value)), PriceChangeIndex_1.PriceChangeIndex.schema.aboveThreshold.valueOfField(source), utils_1.Utils.isValueMissing(source.validationResult) ? ValidationResult_1.ValidationResult.EMPTY : this.validationResultConverter.toObject(source.validationResult, conversions));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {};
      Object.assign(result, {
        value: conversions.fromBigNumber(source.value),
        aboveThreshold: source.aboveThreshold,
        validationResult: this.validationResultConverter.toDocument(source.validationResult, conversions)
      });
      return result;
    }
  }]);

  return PriceChangeIndexConverterImpl;
}(PriceChangeIndexConverter_1.PriceChangeIndexConverter);

PriceChangeIndexConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ValidationResultConverter_1.ValidationResultConverter])], PriceChangeIndexConverterImpl);
exports.PriceChangeIndexConverterImpl = PriceChangeIndexConverterImpl;